import React, { Component } from 'react'
import { connect } from 'react-redux'
import { HeaderTop, StartSection, QuestionnaireList } from '../../components'
import './styles.css'

class Journal extends Component {
  state = {
    sortBy: 'descend'
  }
  render() {
    const {sortBy} = this.state
    return (
      <div className="journal">
        
        <HeaderTop />

        <div className="content">
          
            <StartSection />
            
            <div className="nav-orderby">
              <label>Подреди по:</label>
              <button className={`bttn ${sortBy === "descend" ? "active" : ""}`} onClick={() => this.setState({sortBy: 'descend'})}>Низходящ ред</button>
              <button className={`bttn ${sortBy === "ascend" ? "active" : ""}`} onClick={() => this.setState({sortBy: 'ascend'})}>Възходящ ред</button>
            </div>

        </div>

        <QuestionnaireList sortBy={this.state.sortBy}/>

      </div>
    )
  }
}

export default connect()(Journal)



// WEBPACK FOOTER //
// ./src/screens/Journal/Journal.js